// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"125":"9a9ee589","574":"1bb1b0df","630":"438cf889","713":"ccb8e26a","787":"fc04c886"}[chunkId] + ".chunk.js";
};